export default {
      id: "kiosque_consulter-usage",
      viewBox: "0 0 43 43",
      url: "../dist/images/" + "sprite.svg#kiosque_consulter-usage",
      toString: function () {
        return this.url;
      }
    }